module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SizeImp', {
    staticClass: "contentWrapper",
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "clearSelectedDate": _vm.clearSelectedDate,
      "viewData": _vm.viewData.data
    }
  }), _vm._v(" "), _c('dateTable', {
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "campaginDaysData": _vm.viewData.daysData,
      "dataInfo": _vm.viewData.data,
      "tab": "size"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b671a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/size/SizeMain.vue
// module id = 833
// module chunks = 1